<template>
  <div id="app antialiased">
    <banner phone-number="(929) 930-2262" :on-click="scheduleAppt" />
    <section-header :on-click="scheduleAppt" />
    <main>
      <section-hero
        video-webm="https://s3.us-east-1.amazonaws.com/static.bigleaphealth.com/mrhs/pain-relief.webm"
        video-mp4="https://s3.us-east-1.amazonaws.com/static.bigleaphealth.com/mrhs/pain-relief.mp4"
        poster="https://s3.us-east-1.amazonaws.com/static.bigleaphealth.com/mrhs/pain-still.webp"
        header="Free yourself from Depression & Anxiety"
        lead="Medically supervised TMS & Esketamine treatments for sustained relief in a serene and safe environment."
        :on-click="scheduleAppt"
      />
      <SectionInsurance />
      <delay-hydration>
        <section-doctor />
        <SectionLocations />
        <section-faq />
        <SectionHowItWorks />
        <section-testimonials :testimonials="testimonials" />
        <section-treatments :treatments="treatments" />
        <org-video />
        <section-footer />
      </delay-hydration>
    </main>
  </div>
</template>

<script setup>
import { withQuery } from "ufo";

import KetamineInfusionIcon from "~/assets/images/icons/ketamine-infusion.svg";
import RegenerativeHealthIcon from "~/assets/images/icons/regenerative-health.svg";
import StellateGanglionBlockIcon from "~/assets/images/icons/stellate-ganglion-block.svg";
import TranscranialMagneticStimulationIcon from "~/assets/images/icons/transcranial-magnetic-stimulation.svg";
import NeuroStarLogo from "~/public/images/NeuroStar_Logo.svg";
import NasalSprayIcon from "~/assets/images/icons/nasal-spray.svg";
// Nasal spray will use PNG image path

const { gtag } = useGtag();
const route = useRoute();
const url = withQuery("https://un6a7rqgzdf.typeform.com/to/WXYVrHcK", {
  ...{
    utm_source: "xxxxx",
    utm_medium: "xxxxx",
    utm_campaign: "xxxxx",
    utm_term: "xxxxx",
    utm_content: "xxxxx",
  },
  ...route.query,
});
useSeoMeta({
  title: "Regional Neurological Associates | Psychiatry",
  ogTitle: "Regional Neurological Associates | Psychiatry",
  description:
    "Founded in 1997, RNA is one of the oldest Neurology and Psychiatry  practices in the Bronx and Westchester.",
  ogDescription:
    "Founded in 1997, RNA is one of the oldest Neurology and Psychiatry  practices in the Bronx and Westchester.",
});

const scheduleAppt = () => {
  gtag("event", "schedule_appointment", {
    event_category: "lead",
  });
  navigateTo(url, {
    external: true,
    open: {
      target: "_blank",
    },
  });
};

const testimonials = [
  {
    name: "Sonia, age 49",
    job: "Nurse",
    quote:
      "Dr. Kazmi and his team were incredibly understanding and reassuring from the start. They made the whole process feel straightforward and took the time to explain everything clearly. I felt comfortable and well taken care of the entire time.",
    image: "/images/testimonial1.png",
  },
  {
    name: "Anthony, age 52",
    job: "High School Teacher",
    quote:
      "I was very impressed with the professionalism and care I received from Dr. Kazmi and his staff. They made me feel confident throughout the entire experience, and I would strongly recommend them to anyone.",
    image: "/images/testimonial2.png",
  },
];

const treatments = [
  {
    name: "Botox for Migraines",
    icon: StellateGanglionBlockIcon,
    image: null,
  },
  {
    name: "Transcranial Magnetic Stimulation",
    icon: TranscranialMagneticStimulationIcon,
    image: NeuroStarLogo,
  },
  {
    name: "Regenerative Health",
    icon: RegenerativeHealthIcon,
    image: null,
  },
  {
    name: "Esketamine & Infusions",
    icon: NasalSprayIcon,
    image: null,
  },
];
</script>
